import React from 'react';

import { Carousel } from '../../shared/components/carousel';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';

import '../css/interactive-image.less';

export default ({desktopImgUrl='', hoverSpots=[], isMobile}) => {

    const generateCoordination = (left, top, difference) => {
        return {
            left: `calc(${left}% - ${difference}px)`,
            top: `calc(${top}% - ${difference}px)`
        }
    };

    const carouselRef = React.createRef();

    if(isMobile){
        const settings = {
            renderCenterLeftControls : () => null,
            renderCenterRightControls: () => null,
            slidesToShow:1,
            slidesToScroll: 1
        }
        return(
            <div className="custom-component interactive-image-mobile">
            <Carousel ref={ carouselRef } {...settings}>
            {
                hoverSpots.map((element, i)=>{
                    return(
                        <div className={`carousel-item${!element.mobileImgUrl ? ' no-image' : ''}`} key={`interactive-carousel-item-${i}`}>
                            { element.mobileImgUrl && <ImageWithPlaceholder className='image-overlay' src={element.mobileImgUrl}/> }
                            <p className="popover-header">{element.header}</p>
                            <p className="popover-content">{element.content}</p>
                        </div>
                    )
                })
            }
            </Carousel>
            </div>
        )
    }else{
        return(
            <div className="custom-component interactive-image">
                <ImageWithPlaceholder className='image-overlay' src={desktopImgUrl}/>
                {
                    hoverSpots.map((hoverSpot,i) => {
                        const { header, content, coordination={}, mobileImgUrl, desktopImgUrl=null } = hoverSpot;
                        const { left, top, difference } = coordination;
                        return(
                            <div key={`hover-spot-${i}`} className="hover-wrapper" style={{
                                left: `calc(${left}% - ${difference}px)`,
                                top: `calc(${top}% - ${difference}px)`
                            }}>
                                <div className="hover-point">
                                    <div className="inline-content">
                                    {
                                        desktopImgUrl && <ImageWithPlaceholder className='image-overlay' src={desktopImgUrl}/>
                                    }
                                        <p className="popover-header">{header}</p>
                                        <p className="popover-content">{content}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}
